import React from 'react'

export const PLANS_SETUP_INFO_MESSAGE =
  'For the Plan and Payment amount related configuration will be set inside the Plans setup'

export const CHECKOUT_SETUP_INFO_MESSAGE =
  'For the checkout bottom sheet and payment flow related configuration will be set inside the Custom Checkout Configuration'

interface InfoBannerProps {
  message: string
  className?: string
}

const InfoBanner: React.FC<InfoBannerProps> = ({ message, className = 'mb-6' }) => (
  <div
    className={`rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-800 dark:bg-blue-950/40 ${className}`}
  >
    <p className="text-sm font-medium text-blue-800 dark:text-blue-200">{message}</p>
  </div>
)

export default InfoBanner
